// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInternalDevkitPortalSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#internal-devkit-portal-solid_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.492 20.492c-1.107 1.108-2.373 1.978-3.824 2.558-1.477.634-3.06.95-4.668.95a11.82 11.82 0 0 1-4.668-.95 12.475 12.475 0 0 1-3.824-2.558A11.082 11.082 0 0 1 .95 16.668 11.82 11.82 0 0 1 0 12c0-1.609.316-3.191.95-4.668a12.475 12.475 0 0 1 2.558-3.824C4.615 2.4 5.88 1.53 7.332.949A11.82 11.82 0 0 1 12 0c1.609 0 3.191.316 4.668.95a12.474 12.474 0 0 1 3.824 2.558C21.6 4.615 22.47 5.88 23.05 7.332c.634 1.477.95 3.06.95 4.668a11.82 11.82 0 0 1-.95 4.668 12.474 12.474 0 0 1-2.558 3.824zm-10.096-4.557a.547.547 0 0 0-.283-.466c-1.718-.99-2.442-3.31-1.609-5.153.878-1.942 3.154-2.802 5.074-1.915 1.919.888 2.77 3.359 1.892 5.3a3.904 3.904 0 0 1-1.607 1.769.545.545 0 0 0-.285.467v2.432c0 .322.3.561.607.46 3.422-1.135 5.46-4.753 4.63-8.345-.877-3.8-4.634-6.186-8.418-5.299-3.785.888-6.088 4.716-5.21 8.517.554 2.424 2.316 4.355 4.602 5.124.306.103.608-.136.608-.458z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="internal-devkit-portal-solid_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInternalDevkitPortalSolid;
